// eslint-disable-next-line max-classes-per-file
import axios from 'axios';

const BaseOperation = class {
  constructor(iri, params = {}) {
    this.iri = iri;
    this.params = params;
  }

  // eslint-disable-next-line class-methods-use-this
  modifyResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  modifyError(error) {
    return error?.response?.data;
  }

  // eslint-disable-next-line class-methods-use-this
  execute() {
    throw new Error('Implement BaseOperation.execute() method!');
  }
};

const GetOperation = class extends BaseOperation {
  // eslint-disable-next-line class-methods-use-this
  execute() {
    return axios.get(this.iri, { params: this.params });
  }
};

const GetListOperation = class extends GetOperation {
  // eslint-disable-next-line class-methods-use-this
  modifyResponse(response) {
    return {
      items: response.data.member,
      total: response.data.totalItems,
      nextPageExists: !!response.data?.view?.next,
    };
  }
};

const PostOperation = class extends BaseOperation {
  // eslint-disable-next-line class-methods-use-this
  execute() {
    return axios.post(this.iri, this.params);
  }
};

const PatchOperation = class extends BaseOperation {
  // eslint-disable-next-line class-methods-use-this
  execute() {
    return axios.patch(this.iri, this.params);
  }
};

const DeleteOperation = class extends BaseOperation {
  // eslint-disable-next-line class-methods-use-this
  execute() {
    return axios.delete(this.iri);
  }
};

export {
  BaseOperation,
  GetOperation,
  GetListOperation,
  PostOperation,
  PatchOperation,
  DeleteOperation,
};
